<template>
  <div
    class="dropzone"
    @dragover.prevent="onDragOver"
    @dragleave.prevent="onDragLeave"
    @drop.prevent="onDrop"
    @click="select_file"
    :class="{ dragging: isDragging }"
  >

    <input hidden type="file" ref="file_input" @change="handle_file_upload" accept="image/*" />

    <div class="placeholder">
      <i class="fa fa-upload fa-2x"></i>
      <p>{{ $t('FILE.DRAG_OR_CLICK') }}</p>
    </div>
  </div>
</template>

<script>
import { upload_file } from '@/core/services/fileUpload'
import { get_base_url } from '@/core/services/fileDownload'
import axios from 'axios'
import { toasts } from '@/core/mixins/toastr-helper.mixin.js'

export default {
  name: 'MemlistImageDropzoneUpload',
  mixins: [toasts],
  props: {
    value: String,
    base64_preview: String,
    file_type: {
      type: String,
      default: 'FILE_IMAGE'
    },
    is_public: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isDragging: false,
      preview_url: null
    }
  },
  watch: {
    value(new_val) {
      if (new_val) {
        this.load_image_url(new_val)
      } else if (this.base64_preview) {
        this.preview_url = this.base64_preview
      }
    },
    base64_preview(new_val) {
      if (!this.value && new_val) {
        this.preview_url = new_val
      }
    }
  },
  mounted() {
    if (this.value) {
      this.load_image_url(this.value)
    } else if (this.base64_preview) {
      this.preview_url = this.base64_preview
    }
  },
  methods: {
    select_file() {
      this.$refs.file_input.click()
    },
    onDragOver() {
      this.isDragging = true
    },
    onDragLeave() {
      this.isDragging = false
    },
    async onDrop(event) {
      this.isDragging = false
      const file = event.dataTransfer.files[0]
      if (file) {
        await this.upload(file)
      }
    },
    async handle_file_upload() {
      const file = this.$refs.file_input.files[0]
      if (file) {
        await this.upload(file)
      }
    },
    async upload(file) {
      if (file.size > 50 * 1024 * 1024) {
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('FILE.MUST_BE_LESS'))
        return
      }

      try {
        const uploaded_file = await upload_file(file, {
          file_type: this.file_type,
          is_public: this.is_public
        })
        this.$emit('uploaded', uploaded_file)
        this.$emit('update:value', uploaded_file.file_id)
        this.toastr('success', this.$t('COMMON.OK'), this.$t('FILE.UPLOADED'))
        this.load_image_url(uploaded_file.file_id)
      } catch (err) {
        console.error('upload error', err)
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('FILE.UNABLE_UPLOAD'))
      }
    },
    async load_image_url(file_id) {
      try {
        const res = await axios.get(`/file/${file_id}`)
        if (res.status === 200) {
          this.preview_url = get_base_url() + `/dlfile/${res.data.linkstr}`
        }
      } catch (err) {
        console.error('load image error', err)
      }
    }
  }
}
</script>

<style scoped>
.dropzone {
  border: 2px dashed #ccc;
  padding: 30px;
  text-align: center;
  cursor: pointer;
  border-radius: 8px;
  transition: background 0.2s;
}
.dropzone.dragging {
  background: #f0faff;
  border-color: #3699ff;
}
.preview img {
  max-width: 100%;
  max-height: 150px;
  border-radius: 6px;
}
.placeholder {
  color: #888;
}
</style>
